module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "registrationSuccessful"
    }
  }, [_c('Background-Image', {
    attrs: {
      "url": "na-praia.jpg",
      "lowResUrl": "na-praia-lowres.jpg",
      "color": "#0288D1"
    }
  }), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-3 col-md-6"
  }, [_c('div', {
    staticClass: "m-t-6 card text-xs-center"
  }, [_c('div', {
    staticClass: "card-header default-color-dark white-text"
  }, [_vm._v("\n            " + _vm._s(_vm.t('Registration')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.t('Thank you for registering')))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("\n              " + _vm._s(_vm.t('You should be receiving an account activation email shortly')) + "\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "registrationSuccessClose"
    },
    on: {
      "click": _vm.redirectHome
    }
  }, [_vm._v(_vm._s(_vm.t('Home')))]), _vm._v(" "), (_vm.lastActivity) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.lastActivity,
      "id": "registrationSuccessClose"
    }
  }, [_vm._v(_vm._s(_vm.t('Go to last visited activity')))]) : _vm._e()])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7020c370", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7020c370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/RegistrationSuccess.vue
// module id = 789
// module chunks = 3